import { render, staticRenderFns } from "./PositionDetailsBlock.vue?vue&type=template&id=33972cb5&scoped=true"
import script from "./PositionDetailsBlock.vue?vue&type=script&lang=js"
export * from "./PositionDetailsBlock.vue?vue&type=script&lang=js"
import style0 from "./PositionDetailsBlock.vue?vue&type=style&index=0&id=33972cb5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33972cb5",
  null
  
)

export default component.exports